import {createSlice} from "@reduxjs/toolkit";
import {initialState} from "./initalState";

// consider: move to projectReducer and, if reasonable, convert projectReducer to combinedReducer or so

export const projectRootSlice = createSlice({
    name: "billing",
    initialState,
    reducers: {
        reset: () => initialState,
    },
});

export const {
    reset
} = projectRootSlice.actions;

export default projectRootSlice.reducer;
